import { Box } from '@chakra-ui/react'
import styled from '@emotion/styled'
import { media } from 'components/utils/breakpoints'

export const ContainerVersion = styled(Box)`
    width: 100%;
    p {
        color: #888891;
        font-size: 1rem;
        transition: opacity 0.2s;
    }
    animation: ${(props: any) => props.open && 'fadeInAnimation ease 1s'};

    @keyframes fadeInAnimation {
        0% {
            opacity: 0;
        }
        100% {
            opacity: 1;
        }
    }
    max-width: ${(props: any) => (props.open ? '240px' : '62px')};
    position: absolute;

    left: 0;
    bottom: 10px;
    transition: 0.3s;

    @media ${media('lg', 'max')} {
        max-width: ${(props: any) => (props.open ? '260px' : '72px')};
    }
`
